import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isFetchingExchangeRates } from '@mews-commander/legacy-entities/src/ducks/exchangeRates';

export default connect(
    createStructuredSelector({
        isFetching: isFetchingExchangeRates,
    })
);
